import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list", "template"]

  add(event) {
    event.preventDefault()

    const specializationName = this.inputTarget.value.trim()

    if (!specializationName) {
      return
    }

    // Check if specialization already exists in the list
    const existingLabels = Array.from(this.listTarget.querySelectorAll('label'))
    const exists = existingLabels.some(label => {
      const text = label.textContent.trim()
      return text === specializationName
    })

    if (exists) {
      this.inputTarget.value = ''
      return
    }

    // Create new checkbox for the specialization
    const checkbox = document.createElement('label')
    checkbox.className = 'flex items-center p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors'
    checkbox.innerHTML = `
      <input type="checkbox"
             name="practice[specializations][]"
             value="${this.escapeHtml(specializationName)}"
             checked
             class="mr-3 h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
      <span class="text-sm font-medium text-gray-700">${this.escapeHtml(specializationName)}</span>
      <span class="ml-2 text-xs text-indigo-600">(Custom)</span>
    `

    // Add to the list
    this.listTarget.appendChild(checkbox)

    // Clear input
    this.inputTarget.value = ''
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
